(function () {
  var drawer = document.getElementById('drawer');
  var overlay = document.getElementById('overlay');
  var itemsEl = document.getElementById('drawer-items');
  var sumEl = document.getElementById('drawer-sum');
  var currency = document.body.getAttribute('data-currency') || 'PLN';

  function money(cents) {
    try {
      return new Intl.NumberFormat('pl-PL', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function open() {
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.hidden = false;
    requestAnimationFrame(function () { overlay.classList.add('open'); });
  }
  function close() {
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('open');
    setTimeout(function () { overlay.hidden = true; }, 250);
  }

  function renderCart(cart) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = cart.item_count;
    });
    var hint = document.querySelector('.drawer__hint');
    if (hint) hint.textContent = cart.item_count ? cart.item_count + ' szt. w koszyku' : 'Dodaj produkt, żeby rozpocząć';

    if (!cart.items || !cart.items.length) {
      itemsEl.innerHTML = '<p class="drawer__empty">Koszyk jest pusty.</p>';
      sumEl.textContent = money(0);
      return;
    }
    itemsEl.innerHTML = cart.items.map(function (it) {
      return '' +
        '<div class="ditem">' +
          '<img src="' + it.image + '" alt="' + String(it.product_title || '').replace(/"/g, '&quot;') + '">' +
          '<div><b>' + it.product_title + '</b>' +
          '<span>' + (it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title + ' · ' : '') + it.quantity + ' szt.</span>' +
          '<button class="remove" type="button" data-key="' + it.key + '">Usuń</button></div>' +
          '<strong>' + money(it.final_line_price) + '</strong>' +
        '</div>';
    }).join('');
    sumEl.textContent = money(cart.total_price);

    itemsEl.querySelectorAll('.remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: btn.getAttribute('data-key'), quantity: 0 })
        })
          .then(function (r) { return r.json(); })
          .then(renderCart)
          .catch(function () {});
      });
    });
  }

  function refresh() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  document.querySelectorAll('form[data-quick-add]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button');
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Dodaję…'; }
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          if (btn) { btn.textContent = 'Dodano ✓'; }
          refresh();
          open();
          setTimeout(function () {
            if (btn) { btn.disabled = false; btn.textContent = original; }
          }, 1500);
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.textContent = 'Spróbuj ponownie'; }
        });
    });
  });

  document.querySelectorAll('.cart-trigger').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      refresh();
      open();
    });
  });
  var closeBtn = document.getElementById('drawer-close');
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (overlay) overlay.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  var burger = document.getElementById('burger');
  var nav = document.getElementById('nav');
  if (burger && nav) {
    burger.addEventListener('click', function () { nav.classList.toggle('open'); });
    nav.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') nav.classList.remove('open');
    });
  }

  var qtyInputs = document.querySelectorAll('form[data-qty-form] .qty');
  qtyInputs.forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = b.getAttribute('data-step') === 'down' ? -1 : 1;
        var min = parseInt(input.getAttribute('min') || '1', 10);
        var next = Math.max(min, (parseInt(input.value, 10) || 1) + step);
        input.value = next;
      });
    });
  });

  refresh();
})();